import {
  BasicTimeline,
  BasicTimelineEvent,
  BasicTimelineEventData
} from 'components/Timeline';
import { getTrans } from 'modules/i18n';
import { isEffectiveValueVisible } from 'modules/week-details';
import { DEFAULT_TIMEZONE } from 'utils/date';
import { useShift } from '../hooks';
import {
  getFullDateTimeLabelWithTimezone,
  getShiftBreaksDataWithTimezone
} from '../utils';

export const ShiftTimeline = () => {
  const { shift } = useShift();

  if (!shift) return null;

  const {
    shiftStatus,
    reportedShiftStart,
    effectiveShiftStart,
    reportedShiftEnd,
    effectiveShiftEnd,
    shiftBreaks
  } = shift;

  const shiftStartValue =
    reportedShiftStart &&
    getFullDateTimeLabelWithTimezone(reportedShiftStart, DEFAULT_TIMEZONE);

  const effectiveShiftStartValue =
    effectiveShiftStart &&
    getFullDateTimeLabelWithTimezone(effectiveShiftStart, DEFAULT_TIMEZONE);

  const shiftStartData: BasicTimelineEventData = {
    label: getTrans('shiftDetailsPage.timeline.shiftStart'),
    value: shiftStartValue,
    newValue:
      effectiveShiftStart &&
      isEffectiveValueVisible(
        effectiveShiftStart,
        reportedShiftStart,
        shiftStatus
      )
        ? effectiveShiftStartValue
        : undefined
  };

  const shiftBreaksData: BasicTimelineEventData[] | undefined =
    getShiftBreaksDataWithTimezone(shiftBreaks, shiftStatus, DEFAULT_TIMEZONE);

  const reportedShiftEndValue =
    reportedShiftEnd &&
    getFullDateTimeLabelWithTimezone(reportedShiftEnd, DEFAULT_TIMEZONE);

  const effectiveShiftEndValue =
    effectiveShiftEnd &&
    getFullDateTimeLabelWithTimezone(effectiveShiftEnd, DEFAULT_TIMEZONE);

  const shiftEndData: BasicTimelineEventData = {
    label: getTrans('shiftDetailsPage.timeline.shiftEnd'),
    value: reportedShiftEndValue,
    newValue:
      effectiveShiftEnd &&
      isEffectiveValueVisible(effectiveShiftEnd, reportedShiftEnd, shiftStatus)
        ? effectiveShiftEndValue
        : undefined
  };

  const timelineEvents: BasicTimelineEventData[] = shiftBreaksData ?? [];
  timelineEvents.unshift(shiftStartData);
  timelineEvents.push(shiftEndData);

  return (
    <BasicTimeline>
      {timelineEvents.map((timeEvent, index) => {
        const { label, value, newValue } = timeEvent;
        const isLastItem = index === timelineEvents.length - 1;

        return (
          <BasicTimelineEvent
            key={value}
            label={label}
            value={value}
            newValue={newValue}
            isLastItem={isLastItem}
          />
        );
      })}
    </BasicTimeline>
  );
};
